/**
 * External Dependencies
 */
import 'jquery';

import SimpleBar from 'simplebar'; // nice scroll bar on windows

import { library, dom } from '@fortawesome/fontawesome-svg-core';
import { faFacebookF,faFacebookSquare, faTwitter, faInstagram, faYoutube, faTiktok, faLinkedin, faLinkedinIn} from '@fortawesome/free-brands-svg-icons'
import { faAngleRight,faAngleLeft,faDownload, faEnvelope, faSearch, faPhone } from '@fortawesome/free-solid-svg-icons';

import 'slick-carousel/slick/slick.min'
import Tabs from 'bootstrap/js/dist/tab';
import Accordion from 'bootstrap/js/dist/collapse';


$(() => {
  library.add(faFacebookF,faFacebookSquare, faTwitter, faInstagram, faYoutube, faLinkedin, faLinkedinIn, faAngleRight, faAngleLeft, faDownload, faEnvelope, faSearch, faPhone, faTiktok);
  dom.watch();

  /**
   * Nice scroll bar on windows
   */

  if (document.getElementById('simple-bar') !== null ) {
    new SimpleBar(document.getElementById('simple-bar'), {
      // autoHide: true,
      // classNames: {
      //   content: 'simplebar-content',
      //   scrollContent: 'simplebar-scroll-content',
      //   scrollbar: 'simplebar-scrollbar',
      //   track: 'simplebar-track'
      // },
      // scrollbarMinSize: 25
    })
  }

  $('#show-menu').on('click', function (e) {
    e.stopPropagation();
    // e.preventDefault();
    $(this).toggleClass('is-active');
    // $('.nav-primary').toggleClass('show');
    $('body').toggleClass('body-fixed');
    $('#mobile-menu').toggleClass('open');
  });

  $('#mobile-menu .mobile-menu__primary .nav > .menu-item-has-children > a').on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    $(this).parent().toggleClass('active');
  });

  $(document).on('click', function (e) {
      // console.log('click close menu');
      if ( $("#show-menu").hasClass('is-active') ) {
        $('#show-menu').removeClass('is-active');
        $("#mobile-menu").removeClass('open');
        $('body').removeClass('body-fixed');
      }
  });

  let btnPulse = document.querySelectorAll('.btn-pulse');
  if (btnPulse.length) {
    for (let i = 0; i < btnPulse.length; i++) {
      btnPulse[i].addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        // get link from a child
        const link = this.querySelector('a').getAttribute('href');
        // onclick="Calendly.showPopupWidget('{{ $acf['link']['url'] }}' ); return false;"
        Calendly.showPopupWidget(link);
      });
    }
  }
  // console.log(btnPulse);




    /* MENU */
    var didScroll;
    var menuItem = $('.navbar-wrapper');
    var lastScrollTop = 0;
    var delta = 5;
    // var navbarHeight = menuItem.outerHeight();
    var navbarHeight = 200;
    // console.log(navbarHeight);

    $(window).scroll(function(){
      didScroll = true;
    });

    setInterval(function() {
      if (didScroll) {
          hasScrolled();
          didScroll = false;
      }
    }, 250);

    function hasScrolled() {
        var st = $(document).scrollTop();

        // Make sure they scroll more than delta
        if(Math.abs(lastScrollTop - st) <= delta) {
          // console.log(lastScrollTop, st, delta)
          return;
        }

        // If they scrolled down and are past the navbar, add class .nav-up.
        // This is necessary so you never see what is 'behind' the navbar.
        if (st > 450) {
          menuItem.addClass('sticky');
        } else {
          menuItem.removeClass('sticky');
        }
        // console.log(navbarHeight + 100);
        if (st > lastScrollTop && st > navbarHeight + 800){
            // Scroll Down
            // console.log('down');
            menuItem.removeClass('nav-down');
          } else {
            if(st + $(window).height() < $(document).height()) {
                menuItem.addClass('nav-down');
            }
        }

        lastScrollTop = st;
    }
  // console.log('Hello world');

  /**
   * Slider offres
   */
  if ($('.slideroffers').length) {
    let $slick_slider = $('.slideroffers');
    let settings = {
      infinite: true,
      dots: true,
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      responsive: [{
        breakpoint: 768,
        settings: 'unslick',
      }, ],
    }

    $slick_slider.slick(settings);

    // reslick only if it's not slick()
    $(window).on('resize', function () {
      if ($(window).width() < 768) {
        return
      }

      if (!$slick_slider.hasClass('slick-initialized')) {
        return $slick_slider.slick(settings);
      }
    });

  }

  if ($('.slider-testimonies').length) {

    let $slick_slider = $('.slider-testimonies');
    let settings = {
      infinite: true,
      dots: false,
      arrows: true,
      autoplay: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 990,
          settings: {
            arrows: false,
            dots: true,
          },
        },
      ],
    }

    $slick_slider.slick(settings);
  }

  var triggerTabList = [].slice.call(document.querySelectorAll('#formTabs button'))
  triggerTabList.forEach(function (triggerEl) {
    var tabTrigger = new Tab(triggerEl)

    triggerEl.addEventListener('click', function (event) {
      event.preventDefault()
      tabTrigger.show()
    })
  })

  $('.list-accordian__title').on('click', function (e) {
    e.preventDefault();
    $(this).toggleClass('show');
  });

});


tabControl();
setTimeout(function () {
  $('#description-tab .item-title').trigger('click');
}, 250);

/*
We also apply the switch when a viewport change is detected on the fly
(e.g. when you resize the browser window or flip your device from
portrait mode to landscape). We set a timer with a small delay to run
it only once when the resizing ends. It's not perfect, but it's better
than have it running constantly during the action of resizing.
*/
var resizeTimer;
var width = $(window).width();
$(window).on('resize', function (e) {
  clearTimeout(resizeTimer);
  if ($(window).width() == width)
    return;

  width = $(window).width();
  resizeTimer = setTimeout(function () {
    tabControl();
  }, 250);
});

/*
The function below is responsible for switching the tabs when clicked.
It switches both the tabs and the accordion buttons even if
only the one or the other can be visible on a screen. We prefer
that in order to have a consistent selection in case the viewport
changes (e.g. when you esize the browser window or flip your
device from portrait mode to landscape).
*/
function tabControl() {
  var tabs = $('.tabbed-content').find('.tabs');
   $('.item-title').removeClass('active');
   $('.nav-tab-formation li:first-child a').trigger('click');

  if (tabs.is(':visible')) {
    // console.log('visible');
    tabs.find('a').on('click', function (event) {
      event.preventDefault();
      var target = $(this).attr('href'),
        tabs = $(this).parents('.tabs'),
        buttons = tabs.find('a'),
        item = tabs.parents('.tabbed-content').find('.item');
      buttons.removeClass('active');
      item.removeClass('active');
      $(this).addClass('active');
      $(target).addClass('active');
    });
  } else {
    $('.item-title, .item').removeClass('active');

    $('.item-title').on('click', function (e) {
      // console.log('invisible click');
      e.preventDefault();
      $(this).toggleClass('active').next().slideToggle();
    });
  }
}
